import Typography from "@mui/material/Typography";

export function FoundryPlayerSettings() {
    return (
      <div className="homepage">
      <Typography variant="h1" align='center' padding={'20px'}>Settings for Players!</Typography>
      <Typography variant="body2" align='center'>The amount of settings and their look changed in Foundry v10. I have also changed the amount of Modules. So this section in being reworked.</Typography>
    </div>
    )
}